import "../../../../../../vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { injectProp } from "../private.inject-obj-prop/inject-obj-prop.es.js";
import { reactive, markRaw } from "../../../../../../@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
import { defineComponent } from "../../../../../../@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
function createComponent(raw) {
  return markRaw(defineComponent(raw));
}
function createDirective(raw) {
  return markRaw(raw);
}
const createReactivePlugin = (state, plugin) => {
  const reactiveState = reactive(state);
  for (const name in state) {
    injectProp(
      plugin,
      name,
      () => reactiveState[name],
      (val) => {
        reactiveState[name] = val;
      }
    );
  }
  return plugin;
};
export {
  createComponent,
  createDirective,
  createReactivePlugin
};
//# sourceMappingURL=create.es.js.map
